import { useRequestHeaders } from "#imports";
export function useNaiveDevice() {
  const userAgent = import.meta.client ? navigator.userAgent : useRequestHeaders()["user-agent"] ?? "";
  const isMobileOrTablet = /Mobi|Tablet|Android|Pad/i.test(userAgent);
  const isMobile = /Mobi/i.test(userAgent);
  return { isMobileOrTablet, isMobile };
}
